
export enum HideCategoryStandard {
  StandardASDA = "ASDA AA",
  StandardBRCGSCompliance = "BRCGS Compliance",
  FoodCategoriesAOECS="VM AOECS Gluten-Free Foods",
  FoodCategoriesFSMA="VM - FSMA Preventative Controls and FSVP Preparedness",
  GlutenFreeCategoriesGluten="01 - Gluten Free Certification Program",
  GlutenFreeCategoriesGFCP="GFCP plus AOECS"
}
